export default "__VITE_ASSET__DR4A5AOJ__"